export var RADIAN = Math.PI / 180;
export var SIZE_S = 'SMALL';
export var SIZE_M = 'MEDIUM';
export var SIZE_L = 'LARGE';
export var DEFAULT_STROKE_COLOR = '#fff';
export var APPROXIMATION_MARGIN = 5;
export var LABEL_MARGIN = 10;
export var PERCENT_TYPE = 'PERCENTAGE';
export var RECORD_TYPE = 'RECORDS';
export var AMOUNT_TYPE = 'AMOUNT';
//# sourceMappingURL=constants.js.map